<template>
    <div class="header">

        <div class="header-left">
            <a href="#default" class="logo">
                <div>
                    <img alt="Yoga By Ian" src="../../assets/logo/ybi-logo-main.png" class="logo-img">
                </div>
            </a>
        </div>

        <div class="header-middle">
            <div><a href="#schedule">{{ $t('topMenuItem1') }}</a></div>
            <div><a href="#classes">{{ $t('topMenuItem2') }}</a></div>
            <div><a href="#about">{{ $t('topMenuItem3') }}</a></div>
        </div>

        <div class="header-right">
            <div class="locale-changer">
                <div class="locale-label">
                    {{ $t('labelLanguage') }}
                </div>
                <div>
                    <select v-model="$i18n.locale">
                        <option v-for="locale in $i18n.availableLocales" :key="`locale-${locale}`" :value="locale">{{ locale }}</option>
                    </select>
                </div>
            </div>
        </div>
    </div> 

</template>

<script>
    import { i18n } from '@/plugins/i18n.ts';

    export default {
        name: 'AppHeader',
        data() {
        return {
            languages: [
                { flag: 'gb', language: 'en', title: 'English' },
                { flag: 'es', language: 'es', title: 'Español' }
            ]
        };
    },
    methods: {
        changeLocale(locale) {
            i18n.global.locale = locale;
        }
    }
    ,
    components: {
        
        }
    }

</script>

<style>

    .header {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding-bottom: 10px;
    }

    .header img {
        height: 100px;
    }

    .header-middle {
        display: flex;
        align-items: flex-end;
        padding-left: 20px;
        /* border: 2px dotted; */
    }

    .header-middle div {
        margin-bottom: 0px;
        padding-left: 10px;
    }

    .header-middle a {
        display: block;
        color: black;
        padding-left: 12px;
        padding-right: 12px;
        padding-bottom: 16px;
        text-decoration: none;
        font-size:22px;
        font-weight: normal;
    }

    .header a:hover {
        color: rgb(48, 160, 63);
    }

    .header-right {
        font-size:10px;
    }

    .locale-changer {
        display: flex;
        align-items:center;
        width: 150px;
        margin: 2px;
        padding: 2px;
        border: 2px solid;
        border-color:darkgreen;
        border-radius: 6px;
        background-color: #e2f8d2;
    }

   @media screen and (max-width: 770px) {

        .header img {
            margin-left: 0px;
            height: 70px;
        }

        .header-middle {
            margin-bottom: 0px;
            padding-left: 0px;
        }

        .header-middle div {
            margin-bottom: 0px;
            padding-left: 8px;
        }

        .header-middle a {
            padding-left: 0px;
            padding-right: 0px;
            padding-bottom: 12px;
            font-size: 12px;
        }

        .locale-changer {
            width: 44px;
        }

        .locale-label {
            display: none;
        }
    }

</style>
